import { render, staticRenderFns } from "./BaseGridMask.vue?vue&type=template&id=95bf9b92"
import script from "./BaseGridMask.vue?vue&type=script&lang=ts"
export * from "./BaseGridMask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports